<template>
  <b-modal
    title="رزرو زمان برای زبان آموز VIP"
    :id="`modal-vip-reserve-${scheduleDetails.masterScheduleId}`"
    centered
    ok-title="ثبت"
    cancel-title="بستن"
    ok-variant="success"
    no-close-on-backdrop
    :ok-disabled="isLoading"
    @ok.prevent="sendUpdateRequestAlongWithRepeatedWeekDays"
  >
    <!-- @ok="sendVipUserReserveRequest" -->
    <b-container fluid>
      <vip-user-picker
        :default-user-id="vipUserReserveDetails.userId"
        @getUserId="setUserId"
        @click.prevent
      ></vip-user-picker>

      <div class="d-flex align-items-center mb-1">
        <p class="mb-0 mr-1">از:</p>
        <b-input-group class="input-group-merge">
          <b-form-input
            :id="`startTime`"
            :class="`startTime`"
            placeholder="از ساعت"
          ></b-form-input>
          <b-input-group-append is-text>
            <feather-icon class="cursor-pointer" icon="ClockIcon" size="18" />
            <date-picker
              v-model="vipUserReserveDetails.startDate"
              :customInput="`.startTime`"
              :jumpMinute="10"
              :roundMinute="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="HH:mm"
              type="time"
            ></date-picker>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="d-flex align-items-center mb-1">
        <p class="mb-0 mr-1">تا:</p>
        <b-input-group class="input-group-merge">
          <b-form-input
            :id="`endTime`"
            :class="`endTime`"
            placeholder="تا ساعت"
          ></b-form-input>
          <b-input-group-append is-text>
            <feather-icon class="cursor-pointer" icon="ClockIcon" size="18" />
            <date-picker
              v-model="vipUserReserveDetails.endDate"
              :customInput="`.endTime`"
              :jumpMinute="10"
              :roundMinute="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="HH:mm"
              type="time"
            ></date-picker>
          </b-input-group-append>
        </b-input-group>
      </div>
      <hr class="w-100" />
      <b-row>
        <template v-if="availableWeekDays && availableWeekDays.length > 0">
          <b-col
            style="padding: 2px"
            cols="4"
            v-for="(date, index) in availableWeekDays"
            :key="index"
          >
            <b-form-checkbox
              :checked="isDateExistInRepeat(date)"
              name="check-button"
              switch
              @change="setWeekDayForRepeatVipReserve($event, date)"
            >
              {{ getWeekDay(date) }}
            </b-form-checkbox>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="12">زمان دیگری جهت انتخاب وجود ندارد!</b-col>
        </template>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  emits: ["loaded", "loading", "updateMasterPeriods", "resetCreateVipModal"],
  props: {
    scheduleDetails: {
      type: Object,
      required: true,
    },
    availableWeekDays: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      vipUserReserveDetails: {
        id: 0,
        userId: null,
        startDate: null,
        endDate: null,
        // expireTime: null,
      },
      weekDayForRepeatVipReserve: [],
    };
  },
  methods: {
    // generateNextExpiredTime(curStartDate, defDay) {
    //   return new Date(new Date(curStartDate).getTime() - defDay).toISOString();
    // },
    sendUpdateRequestAlongWithRepeatedWeekDays() {
      let localWeekDaysArray = [];
      this.synchronizeVipDateWithScheduleDate();
      localWeekDaysArray.push(this.vipUserReserveDetails);
      let baseDT = this.vipUserReserveDetails;
      this.weekDayForRepeatVipReserve.forEach((myBT) => {
        let myBaseTime = new Date(myBT);
        let baseDTStartDate = new Date(baseDT.startDate);
        let baseDTEndDate = new Date(baseDT.endDate);
        let curStartDate = new Date(
          myBaseTime.getFullYear(),
          myBaseTime.getMonth(),
          myBaseTime.getDate(),
          baseDTStartDate.getHours(),
          baseDTStartDate.getMinutes(),
          0
        ).toISOString();
        localWeekDaysArray.push({
          userId: baseDT.userId,
          startDate: curStartDate,
          endDate: new Date(
            myBaseTime.getFullYear(),
            myBaseTime.getMonth(),
            myBaseTime.getDate(),
            baseDTEndDate.getHours(),
            baseDTEndDate.getMinutes(),
            0
          ).toISOString(),
        });
      });
      localWeekDaysArray = localWeekDaysArray.sort(function (a, b) {
        return (
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        );
      });
      localWeekDaysArray.forEach(async (payload) => {
        await this.sendVipUserReserveRequest(payload);
      });
    },
    setWeekDayForRepeatVipReserve(isChecked, date) {
      if (isChecked) {
        this.setDateToWeekDayForRepeat(date);
      } else {
        this.removeDateToWeekDayForRepeat(date);
      }
    },
    setDateToWeekDayForRepeat(date) {
      this.weekDayForRepeatVipReserve.push(date);
    },
    removeDateToWeekDayForRepeat(date) {
      this.weekDayForRepeatVipReserve = this.weekDayForRepeatVipReserve.filter(
        (time) => time != date
      );
    },
    getWeekDay(dateObject) {
      if (dateObject) {
        return new Date(dateObject).toLocaleDateString("fa-IR", {
          weekday: "long",
        });
      }
    },
    isDateExistInRepeat(date) {
      if (
        this.weekDayForRepeatVipReserve &&
        this.weekDayForRepeatVipReserve.length > 0
      ) {
        if (this.weekDayForRepeatVipReserve.includes(date)) {
          return true;
        }
        return false;
      }
    },
    resetCreateVipModal() {
      this.$emit("resetCreateVipModal");
    },
    async sendVipUserReserveRequest(reserveDetails) {
      try {
        this.isLoading = true;
        let _this = this;
        let createVipUserReserve = new CreateVipUserReserve(_this);
        createVipUserReserve.setRequestParamDataObj(
          // _this.vipUserReserveDetails
          reserveDetails
        );
        return new Promise(async (resolve, reject) => {
          await createVipUserReserve.fetch((res) => {
            if (res.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "رزرو شد",
                  icon: "CheckIcon",
                  variant: "success",
                  text: "زمانبندی با موفقیت رزرو شد",
                },
              });
              _this.$emit("updateMasterPeriods");
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.message || "لطفا دوباره امتحان کنید!",
                },
              });
            }
          });
          resolve();
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.$emit("loaded");
      }
    },
    synchronizeVipDateWithScheduleDate() {
      // Set Start and end of vipUserReservationDetails
      // To Selected schedule Date
      this.vipUserReserveDetails.startDate = new Date(
        new Date(this.vipUserReserveDetails.startDate).setFullYear(
          new Date(this.scheduleDetails.startTime).getFullYear(),
          new Date(this.scheduleDetails.startTime).getMonth(),
          new Date(this.scheduleDetails.startTime).getDate()
        )
      ).toISOString();
      this.vipUserReserveDetails.startDate = new Date(
        new Date(this.vipUserReserveDetails.startDate).setHours(
          new Date(this.vipUserReserveDetails.startDate).getHours(),
          new Date(this.vipUserReserveDetails.startDate).getMinutes(),
          0
        )
      ).toISOString();
      this.vipUserReserveDetails.endDate = new Date(
        new Date(this.vipUserReserveDetails.endDate).setFullYear(
          new Date(this.scheduleDetails.endTime).getFullYear(),
          new Date(this.scheduleDetails.endTime).getMonth(),
          new Date(this.scheduleDetails.endTime).getDate()
        )
      ).toISOString();
      this.vipUserReserveDetails.endDate = new Date(
        new Date(this.vipUserReserveDetails.endDate).setHours(
          new Date(this.vipUserReserveDetails.endDate).getHours(),
          new Date(this.vipUserReserveDetails.endDate).getMinutes(),
          0
        )
      ).toISOString();
    },
    setUserId(userId) {
      this.vipUserReserveDetails.userId = userId;
    },
  },
  components: {
    BModal,
    BContainer,
    VipUserPicker,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BRow,
    BCol,
  },
};
import {
  BModal,
  BContainer,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BRow,
  BCol,
} from "bootstrap-vue";
import VipUserPicker from "@/views/components/VipUser/VipUserPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { CreateVipUserReserve } from "@/libs/Api/VipUserReserve";
</script>
